import $http from "@/services/Http";
import { prefix } from "@/api/config";
import { AxiosPromise } from "axios";
import Country from "@/models/Country";

export function search(query: string): AxiosPromise<Country[]> {
  return $http.get(`${prefix}/countries/search`, { params: { query } });
}
